import { p } from '@/plugins/permission'
import Vue from 'vue'
import vueResource from 'vue-resource'
Vue.use(vueResource)

const user = []

export default {
  index: {
    permission: [p.schoolManage, p.support],
    addPath: {},
    filters: [{
      value: 'group_id',
      type: 'hidden'
    }],
    tableItems: [{
      label: 'schoolGroup.index',
      value: 'group_name'
    }, {
      label: 'normal.name',
      value: 'name'
    }],
    buttonItems: [{
      buttonName: 'button.delete',
      type: 'ajax',
      path: '/api/school_group_member/delete?id=%member_id%',
      showIf: key => { return true }
    }]
  },
  add: {
    permission: [p.schoolManage, p.support],
    formItems: [{
      label: 'normal.name',
      value: 'user_id',
      option: user,
      filterable: true,
      url: '/api/user/getSomeOne',
      rule: [
        { required: false, message: { text: 'formRule.normal.required', msg: 'normal.name' }, trigger: 'blur' }
      ],
      remoteMethod: async q => {
        if (q) {
          user.splice(0, user.length)
          const res = await Vue.http.get('/api/user/getSomeOne?label=' + q)
          user.push({
            label: '删除',
            value: 0
          })
          for (let i = 0; i < res.data.data.length; i++) {
            user.push(res.data.data[i])
          }
        }
      }
    }, {
      label: 'schoolGroup.index',
      value: 'group_id',
      option: 'school_group',
      rule: [
        { required: true, message: { text: 'formRule.normal.required', msg: 'schoolGroup.index' }, trigger: 'blur' }
      ]
    }]
  }
}
